<template>
  <div>
    <b-overlay :show="loadingUser" opacity="0.99">
      <v-btn class="v-primary mb-1" v-on:click="handleModalCreate">
        <span class="fa fa-plus"></span> Novo
      </v-btn>

      <b-modal
        size="lg"
        id="create"
        hide-footer
        title="Novo usuário"
        no-close-on-backdrop
      >
        <div class="container">
          <form v-on:submit="create" method="post">
            <div class="row">
              <div class="col-md-12 mt-0 pt-0 mb-0 pb-0">
                <LabelRequiredField label="Nome" />
                <input type="text" v-model="name" class="form-control" />
              </div>
              <div class="col-md-6 mt-0 pt-0 mb-0 pb-0">
                <LabelRequiredField label="E-Mail" />
                <input type="email" v-model="email" class="form-control" />
              </div>
              <div class="col-md-3 mt-0 pt-0 mb-0 pb-0">
                <LabelRequiredField label="Senha" />
                <input
                  type="password"
                  v-model="password"
                  class="form-control"
                  autocomplete="off"
                />
              </div>
              <div class="col-md-3 mt-0 pt-0 mb-0 pb-0">
                <LabelRequiredField label="Confirma senha" />
                <input
                  type="password"
                  v-model="confirm_password"
                  class="form-control"
                  autocomplete="off"
                />
              </div>

              <div class="col-md-4 mt-0 pt-0 mb-0 pb-0">
                <LabelRequiredField label="Grupo" />
                <select v-model="user_group_id" class="form-control">
                  <option value>SELECIONE...</option>
                  <option
                    v-for="value in userGroups"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{ String(value.name).toUpperCase() }}
                  </option>
                </select>
              </div>
              <div class="col-md-4 mt-0 pt-0 mb-0 pb-0">
                <LabelRequiredField label="Perfil" />
                <select v-model="user_profile_id" class="form-control">
                  <option value>SELECIONE...</option>
                  <option
                    v-for="value in userProfiles"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{ String(value.name).toUpperCase() }}
                  </option>
                </select>
              </div>
              <div class="col-md-4 mt-0 pt-0 mb-0 pb-0">
                <LabelRequiredField label="Status" />
                <select v-model="status_type_id" class="form-control">
                  <option value>SELECIONE...</option>
                  <option
                    v-for="value in statusTypes"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{ String(value.name).toUpperCase() }}
                  </option>
                </select>
              </div>
              <div class="col-md-12 mt-0 pt-0 mb-0 pb-0">
                <WarningRequiredFields />
                <ErrorsMessages :errors="errors" />
              </div>
              <div class="col-md-12 mt-0 pt-0 mb-0 pb-0 text-right">
                <v-btn
                  :disabled="loadingCreate"
                  type="submit"
                  class="v-success"
                >
                  <span class="fa fa-check"></span>
                  {{ loadingCreate ? "Carregando" : "Salvar" }}
                </v-btn>
              </div>
            </div>
          </form>
        </div>
      </b-modal>

      <v-data-table
        dense
        :headers="headers"
        :items="users"
        :footer-props="{
          'items-per-page-options': [100, 200, 300],
          'items-per-page-text': 'Mostrar',
        }"
        @click:row="handleClickRowTable"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
          <b-modal
            size="lg"
            :id="`user_${String(item.id)}`"
            hide-footer
            no-close-on-backdrop
          >
            <template v-slot:modal-title>Editar usuário</template>
            <b-overlay :show="loadingUserUpdate" opacity="0.99">
              <form v-on:submit="update" method="post">
                <div class="row">
                  <div class="col-md-6 mt-0 pt-0 mb-0 pb-0">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>

                  <div class="col-md-6 mt-0 pt-0 mb-0 pb-0">
                    <LabelRequiredField label="E-Mail" />
                    <input type="text" v-model="email" class="form-control" />
                  </div>

                  <div class="col-md-4 mt-0 pt-0 mb-0 pb-0">
                    <LabelRequiredField label="Grupo" />
                    <select v-model="user_group_id" class="form-control">
                      <option value>SELECIONE...</option>
                      <option
                        v-for="value in userGroups"
                        :key="value.id"
                        :value="value.id"
                      >
                        {{ String(value.name).toUpperCase() }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 mt-0 pt-0 mb-0 pb-0">
                    <LabelRequiredField label="Perfil" />
                    <select v-model="user_profile_id" class="form-control">
                      <option value>SELECIONE...</option>
                      <option
                        v-for="value in userProfiles"
                        :key="value.id"
                        :value="value.id"
                      >
                        {{ String(value.name).toUpperCase() }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 mt-0 pt-0 mb-0 pb-0">
                    <LabelRequiredField label="Status" />
                    <select v-model="status_type_id" class="form-control">
                      <option value>SELECIONE...</option>
                      <option
                        v-for="value in statusTypes"
                        :key="value.id"
                        :value="value.id"
                      >
                        {{ String(value.name).toUpperCase() }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12 mt-0 pt-0 mb-0 pb-0">
                    <h6>
                      <span class="text-muted">Criação:</span>
                      {{ formatDate(item.created_at) }}
                    </h6>
                    <h6>
                      <span class="text-muted">Última alteração:</span>
                      {{ formatDate(item.updated_at) }}
                    </h6>
                  </div>
                  <div class="col-md-12 mt-0 pt-0 mb-0 pb-0">
                    <WarningRequiredFields />
                    <ErrorsMessages :errors="errors" />
                  </div>
                  <div class="col-md-12 mt-0 pt-0 mb-0 pb-0 text-right">
                    <v-btn
                      class="v-primary m-1"
                      @click="$bvModal.hide(`user_${String(item.id)}`)"
                    >
                      <span class="fa fa-arrow-left"></span> Voltar
                    </v-btn>
                    <v-btn
                      :disabled="loadingUpdate"
                      type="submit"
                      class="v-success m-1"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingUpdate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </b-overlay>
          </b-modal>
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import WarningRequiredFields from "../components/WarningRequiredFields";

import LabelRequiredField from "../components/LabelRequiredField";

import ErrorsMessages from "../components/ErrorsMessages";

import api from "../../services/api";

import toast from "../../components/ToastNotification";

import { formatDate } from "../../functions/format";

export default {
  name: "RestHomeUser",
  components: {
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],

      headers: [
        { text: "Status", value: "status_type_name" },
        { text: "Nome", value: "name" },
        { text: "E-mail", value: "email" },
        { text: "Perfil", value: "user_profile_name" },
      ],

      rest_home_id: "",

      users: [],
      statusTypes: [],
      userGroups: [],
      userProfiles: [],

      id: "",
      status_type_id: "",
      user_group_id: "",
      user_profile_id: "",
      name: "",
      email: "",

      password: "",
      confirm_password: "",
      loadingUser: true,
      loadingCreate: false,
      loadingUpdate: false,
      loadingUserUpdate: false,
      loadingChangePassword: false,
    };
  },
  created() {
    this.retrieve();
  },

  methods: {
    formatDate,

    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalUser(item.id);
      this.$bvModal.show(`user_${String(item.id)}`);
    },
    async retrieve() {
      const { id } = this.$attrs;

      this.rest_home_id = id;

      await this.getUsers();
      await this.getStatusUsers();
      await this.getUserGroups();
      await this.getUserProfiles();
    },
    async getUsers(page = 1) {
      try {
        this.loadingUser = true;

        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          page,
        };

        const response = await api.get("/admin/rest-home/users/paginate", {
          params,
        });

        const { users } = response.data;

        this.users = users;

        this.loadingUser = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getStatusUsers() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          type: "USUARIO",
        };

        const response = await api.get("/admin/rest-home/type/status/all", {
          params,
        });

        const { status } = response.data;

        this.statusTypes = status;
      } catch (error) {
        console.log(error);
      }
    },

    async getUserGroups() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
        };

        const response = await api.get("/admin/rest-home/groups", {
          params,
        });

        const { groups } = response.data;

        this.userGroups = groups;
      } catch (error) {
        console.log(error);
      }
    },

    async getUserProfiles() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
        };

        const response = await api.get("/admin/rest-home/profiles", {
          params,
        });

        const { profiles } = response.data;

        this.userProfiles = profiles;
      } catch (error) {
        console.log(error);
      }
    },

    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const {
          rest_home_id,
          status_type_id,
          user_group_id,
          user_profile_id,
          name,
          email,
          password,
          confirm_password,
        } = this;

        let params = {
          rest_home_id,
          status_type_id,
          user_group_id,
          user_profile_id,
          name,
          email,
          password,
          confirm_password,
        };

        const response = await api.post("/admin/rest-home/user", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          this.status_type_id = "";
          this.user_group_id = "";
          this.user_profile_id = "";
          this.name = "";
          this.email = "";
          this.password = "";
          this.confirm_password = "";
          this.errors = [];

          this.getUsers();

          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleModalCreate() {
      this.errors = [];
      this.status_type_id = "";
      this.user_group_id = "";
      this.user_profile_id = "";
      this.name = "";
      this.cpf = "";
      this.professional_class_council_value = "";
      this.professional_class_council = { id: null, name: null };
      this.email = "";
      this.password = "";
      this.confirm_password = "";
      this.$bvModal.show("create");
    },

    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const {
          id,
          rest_home_id,
          status_type_id,
          user_group_id,
          user_profile_id,
          name,
          email,
        } = this;

        let params = {
          id,
          rest_home_id,
          status_type_id,
          user_group_id,
          user_profile_id,
          name,
          email,
        };

        const response = await api.patch("/admin/rest-home/user", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`user_${String(id)}`);
          this.getUsers();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleModalUser(id) {
      try {
        this.loadingUserUpdate = true;

        this.id = id;

        const { rest_home_id } = this;

        const response = await api.get("/admin/rest-home/user", {
          params: { id, rest_home_id },
        });

        const { user } = response.data;

        this.id = user.id;
        this.name = user.name;
        this.email = user.email;
        this.status_type_id = user.status_type_id;
        this.user_group_id = user.user_group_id;
        this.user_profile_id = user.user_profile_id;

        this.loadingUserUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>